<div class="paste-area" (paste)="handlePaste($event)" *ngIf="isEmpty"
     (click)="onClick()"
     (mouseleave)="onBlur()">
    <span *ngIf="focused"
          class="message ok"> {{'admin.strain.tickets.reports.modal.step3.gageConfiguration.noImageLoaded.focused' | translate}}</span>
    <span *ngIf="!focused"
          class="message not-ok">{{'admin.strain.tickets.reports.modal.step3.gageConfiguration.noImageLoaded.notFocused' | translate}}</span>
</div>
<div class="canvas" (drop)="dropElement($event)" (mouseleave)="mouseleave($event) ">
    <canvas #paint
            id="paint"
            [attr.width]="width"
            [attr.height]="height">
    </canvas>
</div>

<ng-container *ngIf="!isEmpty">
    <div class="menu">
        <i class="fa fa-undo" (click)="undo($event)"></i>
        <div class="arrows" >
            <div class="arrow" *ngFor="let arrow of arrows; let i = index">
              <span>{{ arrow.index }}</span>
              <ng-container [ngTemplateOutlet]="getArrowType(arrow.gageType)"
                            [ngTemplateOutletContext]="{arrow:arrow}">
              </ng-container>
            </div>
        </div>
        <i class="fa fa-repeat" (click)="redo($event)"></i>
    </div>
    <div class="buttons">
        <a *ngIf="!isEmpty" href="#" id="save"
           (click)="downloadImage($event)">{{'admin.strain.tickets.reports.modal.step6.download' | translate}}</a>
        <a *ngIf="!isEmpty" href="#" id="reset"
           (click)="resetImage($event)">{{'admin.strain.tickets.reports.modal.step6.reset' | translate}}</a>
    </div>
</ng-container>

<app-form-error-list *ngIf="showErrors"
                     [errorMap]="formControl.errors"></app-form-error-list>

<ng-template #unidirectional let-arrow='arrow'>
  <img class="arrow"
       id="arrow_simple_{{arrow.index}}"
       src="../../../../../assets/images/arrows/unidirectional.png"
       draggable="true"
       crossorigin="anonymous"
       (dragstart)="dragElement($event)"/>
</ng-template>

<ng-template #bidirectional let-arrow='arrow'>
  <img class="arrow"
       id="arrow_double_{{arrow.index}}"
       src="../../../../../assets/images/arrows/bidirectional.png"
       draggable="true"
       crossorigin="anonymous"
       (dragstart)="dragElement($event)"/>
</ng-template>

<ng-template #tridirectional let-arrow='arrow'>
  <img class="arrow"
       id="arrow_triple_{{arrow.index}}"
       src="../../../../../assets/images/arrows/tridirectional.png"
       draggable="true"
       crossorigin="anonymous"
       (dragstart)="dragElement($event)"/>
</ng-template>
